const SOFT = '#F3F3F4';
const PRIMARY = '#E76D5E';
const SECONDARY = '#71888E';
const SUCCESS = '#98D8AA';

export { PRIMARY, SECONDARY, SOFT, SUCCESS };
